import { Container } from "./Container";

type Props = {
  eyebrow: string;
  title: string;
  subtitle?: string;
  centered?: boolean;
};

/** Consistent page hero: teal eyebrow, big uppercase title, muted subtitle. */
export const PageHeader = ({
  eyebrow,
  title,
  subtitle,
  centered = false,
}: Props) => (
  <section className="border-b border-border-shell bg-surface-sari">
    <Container>
      <div className={`py-14 md:py-16 ${centered ? "text-center" : ""}`}>
        <p className="font-heading text-sm font-bold uppercase tracking-[0.18em] text-raytio-poolblue-text dark:text-raytio-poolblue">
          {eyebrow}
        </p>
        <h1 className="mt-3 font-heading text-4xl font-extrabold uppercase leading-[1.05] tracking-tight text-text-full sm:text-5xl md:text-6xl">
          {title}
        </h1>
        {subtitle && (
          <p
            className={`mt-4 max-w-2xl text-lg text-text-medium ${
              centered ? "mx-auto" : ""
            }`}
          >
            {subtitle}
          </p>
        )}
      </div>
    </Container>
  </section>
);
